module.exports = __webpack_public_path__ + "img/deductions.d52525fd.svg";